import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { GOOGLE_REVIEWS } from "../../lib/data";

const Stars = () => (
  <span className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={15} className="fill-gold text-gold" />
    ))}
  </span>
);

export const Testimonials = () => (
  <section id="testimonials" className="relative overflow-hidden border-y border-gold-line/60 bg-gold-tint py-24 md:py-32" data-testid="testimonials-section">
    <div className="pointer-events-none absolute -right-32 -top-20 h-[380px] w-[380px] rounded-full bg-gold/15 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading
          overline="Client Testimonials"
          title="Trusted by Clients. Rated 5.0 on Google."
          sub="Real words from clients who navigated their financing journey with LendX."
          testId="testimonials-heading"
        />
        <Reveal delay={0.2}>
          <a
            href={GOOGLE_REVIEWS.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-rating-badge"
            className="flex items-center gap-3 rounded-full border border-gray-200 bg-white px-5 py-3 shadow-[0_2px_10px_rgba(16,20,24,0.05)] transition-transform duration-300 hover:scale-[1.03]"
          >
            <span className="font-heading text-2xl font-bold text-navy">{GOOGLE_REVIEWS.rating}</span>
            <span className="flex flex-col">
              <Stars />
              <span className="mt-0.5 text-[11px] font-semibold text-gray-500">Google Reviews</span>
            </span>
          </a>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-4 md:grid-cols-3">
        {GOOGLE_REVIEWS.reviews.map((r, i) => (
          <Reveal key={r.name} delay={(i % 3) * 0.08} y={28}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="glow-hover flex h-full flex-col justify-between rounded-xl border border-gray-200 bg-white p-8 shadow-[0_2px_10px_rgba(16,20,24,0.04)]"
            >
              <div>
                <Quote size={26} className="text-gold" />
                <blockquote className="mt-5 text-sm leading-relaxed text-gray-600 md:text-base">"{r.text}"</blockquote>
              </div>
              <figcaption className="mt-8 flex items-center justify-between border-t border-gray-100 pt-5">
                <div>
                  <p className="font-heading text-base font-semibold text-navy">{r.name}</p>
                  <p className="mt-0.5 text-xs text-gray-400">Verified Google Review</p>
                </div>
                <Stars />
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.25} className="mt-10">
        <a
          href={GOOGLE_REVIEWS.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="read-all-reviews-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-gold-deep transition-colors duration-300 hover:text-orange-deep"
        >
          Read all reviews on Google →
        </a>
      </Reveal>
    </div>
  </section>
);
